import { render, staticRenderFns } from "./product-info-field.vue?vue&type=template&id=7af8e66a&"
import script from "./product-info-field.vue?vue&type=script&lang=js&"
export * from "./product-info-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports